<script lang="ts">
import { defineComponent } from 'vue';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CIconLeftRight',
	props: {
		isLeft: {
			required: false,
			type: Boolean,
			default: () => false,
		},
		disabled: {
			required: false,
			type: Boolean,
			default: () => false,
		},
	},
	setup() {
		return {
			faChevronLeft,
		};
	},
});
</script>

<template>
	<font-awesome-icon
		:class="[
			'cursor-pointer',
			{ 'c-icon-left-right--left': isLeft },
			{ 'c-icon-left-right--right': !isLeft },
			{ 'c-icon-left-right--disabled': disabled },
		]"
		:icon="faChevronLeft.iconName"
	/>
</template>

<style scoped lang="scss">
.c-icon-left-right--disabled {
	cursor: not-allowed;
	color: tokens.$color-gray-c4;
}

.c-icon-left-right--left {
	transform: rotate(0);
	transition: all 0.6s ease;
}

.c-icon-left-right--right {
	transform: rotate(180deg);
	transition: all 0.6s ease;
}
</style>
